import { getCookie } from 'vanilla-cookieconsent';

export function readAcceptedCategories() {
    if (typeof document === 'undefined') {
        return [];
    }
    try {
        const categories = getCookie('categories');
        return Array.isArray(categories) ? categories : [];
    } catch (err) {
        return [];
    }
}

export function analyticsGranted() {
    return readAcceptedCategories().indexOf('analytics') !== -1;
}

export function marketingGranted() {
    return readAcceptedCategories().indexOf('marketing') !== -1;
}
